$(function() {
  function init_sliders(){
    $('.cpi-variants-container.enable-slider:not(.slick-initialized)').each(function(){
      initial_slide = $(this).find('.cpi-variant.active').index();
      $(this).slick({
        infinite: false,
        centerMode: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        centerPadding: '0px',
        initialSlide: initial_slide,
        responsive:[
          {
            "breakpoint": 350,
            "settings": {
              "slidesToShow": 1
            }
          }
        ]
      });
    });
  }

  function check_tag_and_badges(){
    $('.cct-product-grid-item').each(function(){
      badges_container = $(this).find('.cpi-badges-container');
      badges_container.html('');
      product_tags = $(this).data('product-tags');
      available = $(this).data('available');
      if(available){
        $.each(product_tags, function(index, tag){
          if(tag_badges_array[tag]){
            badges_container.append(`<img class="cpi-badge" src="${tag_badges_array[tag]}">`);
          }
        });
      } else {
        badges_container.html(`<img class="cpi-badge" src="${ tag_badges_array.sold_out }">`);
      }
    });
  }

  function sorting_and_filtering(){
    $('.cct-products-grid').html('<div class="cct-pagination-container"><div class="loader"></div></div>')
    sort_by = $('.cct-sort').val();

    tag_filter_string = '';
    amount_of_active_options = $('.cct-filter-option.active').length - 1;
    $('.cct-filter-option.active').each(function(i){
      value = $(this).data('value');
      if(i == amount_of_active_options){
        tag_filter_string = tag_filter_string + value
      } else {
        tag_filter_string = tag_filter_string + value + '+';
      }
    });

    link = $("#collection_url").val();
    $.ajax({
  		type: 'GET',
  		url: `${link}/${tag_filter_string}?view=ajax-filtering&sort_by=${sort_by}`,
  		success: function(data){
        $('.cct-products-grid').html(data);
        grid_position = $('.cct-products-grid').offset().top - $('.cct-sort-and-filter-container').outerHeight();
        history.replaceState("","",`${link}/${tag_filter_string}?sort_by=${sort_by}`);
        init_sliders();
        check_tag_and_badges()
        $('body, html').animate({scrollTop: grid_position}, 500);
  		}
  	});
  }

  function init_section_sliders(){
    $('[data-slick-settings]').each(function(){
      settings = JSON.parse($(this).data('slick-settings'));
      $(this).slick(settings);
    });
  }

  init_section_sliders();
  init_sliders();
  check_tag_and_badges();

  $('.cct-filter-opener').click(function(){
    $('.cct-filters-modal').fadeIn();
    $('.custom-overlay').fadeIn();
  });
  $('.cct-close-filters-modal').click(function(){
    $('.cct-filters-modal').fadeOut();
    $('.custom-overlay').fadeOut();
  });
  $('.custom-overlay').click(function(){
    $('.custom-overlay').fadeOut();
    $('.cct-filters-modal').fadeOut();
    $('#ch-mobile-wrapper').removeClass('visible');
  });
  $('.cct-filter-name').click(function(){
    $(this).toggleClass('opened');
    $(this).next('.cct-filter-options').slideToggle();
  });

  $('.cct-filter-option').click(function(){
    $(this).toggleClass('active').siblings().removeClass('active');
    sorting_and_filtering();
  });
  $('.cct-sort').change(function(){
    sorting_and_filtering();
  });

  $(document).on('click','.cct-pagination',function(){
    button_parent = $(this).parent();
    url = $(this).data('href');
    button_parent.html('<div class="loader"></div>');
    $.ajax({
      type: 'GET',
  		url: `${url}`,
  		success: function(data){
        button_parent.remove();
        $('.cct-products-grid').append(data);
        init_sliders();
        check_tag_and_badges()
  		}
    });
  });

  $(document).on('click','.cpi-variant', function(){
    grid_item = $(this).parents('.cct-product-grid-item');
    picture_tag = grid_item.find('.cpi-main-image-picture');
    link_container = grid_item.find('.cpi-link-container');
    price = grid_item.find('.cpi-price');
    variants_container = grid_item.find('.cpi-variants-container');

    if($(this).parents('.cpi-variants-container').hasClass('enable-slider')){
      index = $(this).parents('.slick-slide').data('slick-index');
      $(this).parents('.cpi-variants-container').slick('slickGoTo',index);
    }

    desktop_image = $(this).data('desktop-image');
    mobile_image = $(this).data('mobile-image');
    picture_tag.find('source').attr('srcset',mobile_image);
    picture_tag.find('img').attr('src', desktop_image);

    new_href = $(this).data('href');
    link_container.attr('href', new_href);

    new_price = $(this).data('price');
    price.html(new_price);

    available = $(this).data('available');
    grid_item.data('available',available);

    variants_container.find('.cpi-variant').removeClass('active');
    $(this).addClass('active');
    check_tag_and_badges()
  });

  

  function get_header_height(){
    height = $('#shopify-section-custom-header').outerHeight();
    document.body.style.setProperty('--header_height',height + 'px');
  }
  get_header_height();

  $( window ).resize(function() {
    get_header_height();
  });

  //Custom product template
  function check_tag_and_badges_on_product_template(){
    badges_container = $('.cpt-badges-container');
    badges_container.html('');
    product_tags = badges_container.data('product-tags');
    available = badges_container.data('available');
    if(available){
      $.each(product_tags, function(index, tag){
        if(tag_badges_array[tag]){
          badges_container.append(`<img class="cpt-badge" src="${tag_badges_array[tag]}">`);
        }
      });
    } else {
      badges_container.html(`<img class="cpt-badge" src="${ tag_badges_array.sold_out }">`);
    }
  }
  check_tag_and_badges_on_product_template();
  $('.cpt-thumbnail').click(function(){
    index = $(this).parents('.slick-slide').data('slick-index');
    $('.cpt-thumbnails-container').slick('slickGoTo',index);
  });

  
    function trigger_cart_update(){
      $('.site-header__cart.cart-link').first().click();
    }
    $('.cpt-product-form').submit(function(e){
      e.preventDefault();
      Shopify.addItemFromForm(e.target,trigger_cart_update);
    });
  

  $('.cpt-value-block').click(function(){
    $(this).addClass('selected').siblings().removeClass('selected');
    value = $(this).data('value');
    value_name = $(this).parents('.cpt-option-container').find('.cpt-option-value');
    value_name.html(value.toLowerCase());

    variant_title = '';
    amount_of_active_options = $('.cpt-value-block.selected').length - 1;
    $('.cpt-value-block.selected').each(function(i){
      option_value = $(this).data('value');
      if(i == amount_of_active_options){
        variant_title = variant_title + option_value
      } else {
        variant_title = variant_title + option_value + ' / ';
      }
    });

    select = $(this).parents('form').find('[name="id"]');
    // replacing old ambiguous contains selector w custom non-ambiguous selector textEquals for exact match
    //option_from_select = select.find(`option:contains('${variant_title}')`);

    $.expr[':'].textEquals = function(a, i, m) {  
    return $(a).text().match("^" + m[3] + "$");  
     }; 

    option_from_select = select.find(`option:textEquals('${variant_title}')`);
    
    
    variant_id = option_from_select.val();

    variant_price = option_from_select.data('price');
    variant_compare_price = option_from_select.data('compare-price');
    variant_image_id = option_from_select.data('image');
    variant_available = option_from_select.data('available');

    select.val(variant_id);

    //Replace url
    history.replaceState("","",`${window.location.pathname}?variant=${variant_id}`);

    //Change price
    $('.cpt-product-price').html(variant_price);
    $('.cpt-product-compare-price').html(variant_compare_price);

    //Change slider image
    slide_index = $(`.cpt-main-image[data-image-id="${variant_image_id}"]`).parents('.slick-slide').data('slick-index');
    $('.cpt-main-images-container').slick('slickGoTo', slide_index);

    //Check variant availability
    badges_container =  $('.cpt-badges-container');
    badges_container.data('available', variant_available);
    add_to_cart_button = $(this).parents('form').find('.cpt-add-to-cart');
    if(variant_available){
      add_to_cart_button.html(window.productStrings.addToCart).removeAttr('disabled');
    } else {
      add_to_cart_button.html(window.productStrings.soldOut).attr('disabled','disabled');
    }
    check_tag_and_badges_on_product_template();
  });

  $('.cpt-quantity-button').click(function(){
    if($(this).hasClass('cpt-quantity-plus')){
      value = 1;
    } else{
      value = -1;
    }
    current_quantity = $('.cpt-quantity-input').val() * 1;
    if( (current_quantity + value) > 0 ){
      new_quantity = current_quantity + value;
      $('.cpt-quantity-input').val(new_quantity);
    }
  });


  //Tabs
// Hides all tab contents except the last one
$('.cpt-content').not(':last').hide();

// Sets up the click handler for the tab titles
$('body').on('click', '.cpt-title', function(){
    // Check if the clicked tab is already open
    var isOpen = $(this).hasClass('tab-opened');

    // Slide up all contents and remove 'tab-opened' class from all tabs
    $('.cpt-content').slideUp(300);
    $('.cpt-title').removeClass('tab-opened');

    // If the clicked tab was not open, slide it down and add the 'tab-opened' class
    if (!isOpen){
        $(this).next().slideDown(300);
        $(this).addClass('tab-opened');
    }
  
});

// Open the last tab by default
$('.cpt-title:last').addClass('tab-opened').next().slideDown(300);


  //Contact form
  $('#contactFormMessage').on('input', function(){
    length_of_input = $(this).val().length;
    $('.ccf-current-length').text(length_of_input);
  });

  //Stockists
  $('.cstock-mobile-title').on('click', function(){
    $(this).toggleClass('selector-opened');
    $('.cstock-titles-container').slideToggle();
  });

  $('.cstock-title-wrapper ').on('click', function(){
    $('.cstock-title-wrapper').removeClass('active');
    $('.cstock-country-info').removeClass('visible').hide();
    $(this).addClass('active');
    data_id = $(this).data('id');
    $("#" + data_id).addClass('visible').fadeIn();
    $('#selected-country').html($(this).children().html());
    if ($(window).width() < 1024){
      $('.cstock-mobile-title').removeClass('selector-opened');
      $('.cstock-titles-container').slideUp();
    }
  });
});
